import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions'
import { app } from '@/firebase'
const functions = getFunctions(app, 'us-central1')
if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') connectFunctionsEmulator(functions, 'localhost', 5001)
export const completeCafWithPhoto = async (data) => (await httpsCallable(functions, 'completeCafWithPhoto', { timeout: 120000 })(data)).data
